import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "pencil",
  "use": "pencil-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol viewBox=\"0 0 32 32\" xmlns=\"http://www.w3.org/2000/svg\" id=\"pencil\"><path d=\"M30.173 7.542l-.314.314-5.726-5.729.313-.313S25.817.001 27.767.001c.859 0 1.832.353 2.849 1.37 3.354 3.354-.443 6.171-.443 6.171zm-2.194 2.195L8.48 29.243 0 32l2.756-8.485v-.003h.002L22.254 4.007l.252.253zM2.76 29.239l4.237-1.219-2.894-3.082-1.343 4.301z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol